import './styles.scss';
import React, { useState, useEffect } from 'react';
import splashVideo from '../../assets/videos/splash.mp4'; // You'll need to add this video file

const Splash = ({ splashEnded = false }) => {
    const [showSplash, setShowSplash] = useState(true);

    useEffect(() => {
        // Hide splash when splashEnded is true (time-based from parent)
        if (splashEnded) {
            setTimeout(() => {
                setShowSplash(false);
            }, 200); // Small delay for smooth transition
        }
    }, [splashEnded]);

    return (
        <div className={`splash ${!showSplash ? "hide" : ''}`}>
           <video 
               autoPlay
               muted
               playsInline
           >
               <source src={splashVideo} type="video/mp4" />
               Your browser does not support the video tag.
           </video>
        </div>
    )
}

export default Splash;